/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var AirIcon = createIcon("AirIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#B30B00';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.542 28.866a3.92 3.92 0 00-.321-.375c-1.365-1.4-2.385-3.055-2.934-4.887-.026-.085-.051-.17-.074-.256s-.044-.174-.065-.26c-.44-1.861-.386-3.805.098-5.7 0 0 .074-.313.093-.442a4.756 4.756 0 00-9.194-2.317c-.033.088-.1.31-.1.314-.525 1.858-1.436 3.545-2.723 4.925a11.55 11.55 0 01-5.402 3.183 4.76 4.76 0 002.464 9.197c1.895-.484 3.838-.54 5.7-.099a12.373 12.373 0 01.518.139c1.832.55 3.488 1.568 4.887 2.935.172.172.32.293.46.391 1.88 1.433 4.556 1.323 6.27-.391a4.753 4.753 0 00.323-6.357Zm-11.531.86a4.658 4.658 0 112.412-9 4.658 4.658 0 01-2.412 9Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.AirIcon",
  "replaceColor": true
});